import React, { Component } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { Button } from '@trevor/ui-components';
import AjaxSpinner from '../../AjaxSpinner';
import { post } from '../../../util/helpers/ajax-helpers';
import flex from '../../../css/module/flex.css';

//
// https://stripe.com/docs/stripe-js/react#elements-consumer
//
class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      error: null,
      loading: false,
    };
  }

  handleSubmit(event) {
    // Block native form submission.
    event.preventDefault();

    const { stripe, elements, onCardUpdated } = this.props;

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    if (this.state.loading) {
      // don't allow multiple submits
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    this.setState({
      loading: true,
      error: null, // reset
    });
    post(
      'initiating card validation',
      '/api/subscription/initiate-card-validation',
    ).then((respRoot) => {
      // https://stripe.com/docs/payments/save-and-reuse
      stripe
        .confirmCardSetup(respRoot.clientSecret, {
          payment_method: {
            card: cardElement,
          },
        })
        .then((resp1) => {
          const { error, setupIntent } = resp1;
          if (error) {
            this.setState({
              error: error.message,
              loading: false,
            });
          } else {
            post(
              'updating default payment method',
              '/api/subscription/default-payment-method',
              {
                paymentMethod: setupIntent.payment_method,
              },
            ).then((resp2) => {
              onCardUpdated(resp2.cardShortName);
            });
          }
        });
    });
  }

  render() {
    const { stripe } = this.props;

    // see available options: //https://stripe.com/docs/js/elements_object/create_element?type=card
    const CARD_ELEMENT_OPTIONS = {
      // hidePostalCode: true, //it is recommended to request a postal code to increase card acceptance rate (and reduce fraud)
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      },
    };
    return (
      <form onSubmit={this.handleSubmit}>
        <CardElement options={CARD_ELEMENT_OPTIONS} />
        {!this.state.error ? null : (
          <div
            style={{
              backgroundColor: '#ed4337',
              padding: '10px',
              color: '#fff',
              marginTop: '-2px',
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
            }}
          >
            {this.state.error}
          </div>
        )}
        {this.state.loading ? (
          <div
            className={`${flex.row} w-100 ${flex.justifyContentCenter}`}
            style={{ paddingTop: '20px' }}
          >
            <AjaxSpinner small />
          </div>
        ) : (
          <Button
            style={{ width: '100%' }}
            className="margin-top-15"
            disabled={!stripe}
          >
            Save Card
          </Button>
        )}
      </form>
    );
  }
}

export default CheckoutForm;
